import React, { useState, useContext } from 'react';
import { Button, Typography } from '@one-thd/sui-atomic-components';
import { SurveyUnsubscriptionModal } from '../SurveyEmailPreferences/SurveyUnsubscriptionModal';
import {
  unsubscribeFromAllEmail,
  unsubscribeFromAllEmailSuccess
} from '../../analytics/email';
import { addAnalyticEvent } from '../../analytics/common';
import ErrorBoundary from '../../contexts/ErrorBoundary';
import { BannerContext, BannerProvider } from '../../contexts/BannerContext';
import { SURVEY_EMAIL_UNSUBSCRIBE_SUCCESS } from '../../constants/bannerConstants';

export function Preferences() {
  const [unsubscribeToggle, setUnsubscribeToggle] = useState(false);
  const { openSuccessAlert } = useContext(BannerContext);
  const openUnsubscribeModal = () => {
    addAnalyticEvent(unsubscribeFromAllEmail);
    setUnsubscribeToggle(true);
  };

  const handleUnsubCancel = () => {
    setUnsubscribeToggle(false);
  };

  const handleUnsubSuccess = (emailRes) => {
    addAnalyticEvent(unsubscribeFromAllEmailSuccess);
    setUnsubscribeToggle(false);
    openSuccessAlert(SURVEY_EMAIL_UNSUBSCRIBE_SUCCESS, emailRes);
  };

  const handleUnsubError = () => {
  };

  return (
    <div className="sui-grid sui-gap-4">
      <Typography variant="h2" weight="display">SURVEY EMAILS</Typography>
      <Typography variant="body-base" height="none">
        If you don&apos;t want to provide customer feedback, you can unsubscribe from our survey emails.
      </Typography>

      <div className="sui-grid sui-grid-cols-8">
        <div className="hidden sm:sui-col-span-4 md:sui-col-span-5" />
        <div className="sui-col-span-8 sm:sui-col-span-4 md:sui-col-span-3">
          <Button
            aria-label="unSubscribeModalButton"
            data-testid="unSubscribeModalButton"
            fullWidth
            variant="secondary"
            onClick={openUnsubscribeModal}
          >
            Opt Out of Survey Emails
          </Button>
        </div>
      </div>

      {unsubscribeToggle && (
        <SurveyUnsubscriptionModal
          handleClose={handleUnsubCancel}
          handleSuccess={handleUnsubSuccess}
          handleError={handleUnsubError}
        />
      )}
    </div>
  );
}

export function SurveyEmailUnsubscribePreferences() {
  return (
    <ErrorBoundary>
      <BannerProvider>
        <Preferences />
      </BannerProvider>
    </ErrorBoundary>
  );
}
